import { useDialog, useTestStore, useUserStore } from "../../hooks/store";
import Styles from "./TestComponentStyles.module.css";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import {
  testType as testTypeHeler,
  testStatus as testStatusHelper,
} from "../../utils/testHelper";
import { TestGreeting } from "./TestGreeting";
import { TestSolvingSection } from "./TestSolving/TestSolvingSection";
import { useBlocker, useSearchParams } from "react-router";
import { useEffect, useState } from "react";

import { TestTimer } from "./TestTimer";
import { TestFinish } from "./TestFinish";
import { useNavigate } from "react-router";
import { useModal } from "../../hooks/modalStore";

import SolvingHistoryButton from "../SolvingHistoryButton";

export function TestSection() {
  const testStore = useTestStore();
  const [SearchParams, setParams] = useSearchParams();
  const { testTitle, testType, testStatus, testLoading, questionList } =
    testStore;
  const modal = useModal();
  const [onTestReady, setTestReady] = useState(false);
  const nav = useNavigate();
  const { setDialog } = useDialog();
  const userStore = useUserStore();

  // const historyHandleClick = () => {
  //   getLog(null, null, 3).then(({ data, staus }) => {
  //     modal.handleOpen(
  //       <SolvingHistoryGrid title={"Марафон ПДД ПМР"} logData={data} />
  //     );
  //   });
  // };

  const blocker = useBlocker(
    ({ currentLocation, nextLocation, historyAction }) =>
      testStatus === testStatusHelper.start &&
      (testType.type == testTypeHeler.bilet.type ||
        testType.type == testTypeHeler.theme.type ||
        testType.type == testTypeHeler.exam.type) &&
      nextLocation.pathname !== currentLocation.pathname,
  );

  // console.log(blocker);

  useEffect(() => {
    if (blocker.state === "blocked") {
      setDialog(
        "Вы уверены что хотите покинуть страницу?",
        "Если вы покинете страницу решение теста не будет засчиатно",
        () => blocker.reset(),
        () => {
          blocker.proceed();
          testStore.canceleTest();
          testStore.resetTest();
        },
      );
    }
  }, [blocker.state]);

  useEffect(() => {
    const title = SearchParams.get("title");
    const id = SearchParams.get("id");
    const testType = Number(SearchParams.get("testType"));
    const questions = SearchParams.get("questions");

    switch (testType) {
      case testTypeHeler.bilet.type:
        testStore.setBaseData(testTypeHeler.bilet, title, id);
        setTestReady(true);
        break;
      case testTypeHeler.theme.type:
        testStore.setBaseData(
          // {
          //   type: testTypeHeler.theme.type,
          //   conditions: {
          //     ...testTypeHeler.theme.conditions,
          //     questionCount: testTypeHeler.theme.conditions.getquestionCount(
          //       questions,
          //       title,
          //     ),
          //   },
          // },
          {
            ...testTypeHeler.theme,
            conditions: {
              ...testTypeHeler.theme.conditions,
              questionCount: questions,
            },
          },
          title,
          id,
        );
        setTestReady(true);
        break;
      case testTypeHeler.marathon.type:
        testStore.setBaseData(testTypeHeler.marathon, "Марафон ПДД ПМР", 0);
        setTestReady(true);
        break;
      case testTypeHeler.exam.type:
        testStore.setBaseData(testTypeHeler.exam, "Экзамен ПДДПМР", 0);
        setTestReady(true);
        break;
      default:
        setTestReady(true);
    }
  }, []);

  const renderTestContent = () => {
    switch ((testType, testStatus)) {
      case (true, testStatusHelper.finish):
        return <TestFinish />;

      case (testType.type != testTypeHeler.marathon.type,
      testStatusHelper.canseled):
        return <TestFinish />;

      case (true, testStatusHelper.start):
        return <TestSolvingSection />;

      default:
        return <TestGreeting />;
    }
  };

  const handleBack = () => {
    // eslint-disable-next-line default-case
    switch (testType.type) {
      case testTypeHeler.bilet.type:
        nav("/");

        break;
      case testTypeHeler.marathon.type:
        testStore.canceleTest();
        nav("/");

        break;
      case testTypeHeler.theme.type:
        nav("/theme");

        break;
      case testTypeHeler.exam.type:
        nav("/exam");

        break;

      case testTypeHeler.preview.type:
        testStore.closeTestPreview();
        break;
    }
  };

  // console.log(testStore);
  return (
    <section className={Styles.test_section}>
      <div className={Styles.test_header}>
        <ArrowBackRoundedIcon onClick={handleBack} />
        <p>{testTitle}</p>
        {(testStatus == testStatusHelper.start &&
          testType.type !== testTypeHeler.preview.type && <TestTimer />) ||
          (testStatus == testStatusHelper.prepare &&
            testTypeHeler.marathon.type == testType.type && (
              <div
                style={{
                  transition: "inherit !important",
                  justifySelf: "end",
                  marginLeft: "auto",
                }}>
                <SolvingHistoryButton
                  title={"История решений"}
                  biletId={null}
                  themeId={null}
                  type={testTypeHeler.marathon.type}
                />
              </div>
              // <Tooltip
              //   placement="top"
              //   title={"История решений"}
              //   sx={{
              //     transition: "inherit !important",
              //     justifySelf: "end",
              //     marginLeft: "auto",
              //   }}>
              //   <HistoryRoundedIcon
              //     className={`${
              //       !userStore.isAuth && ExamCard.disabled_history
              //     }`}
              //     onClick={historyHandleClick}
              //   />
              // </Tooltip>
            ))}
      </div>
      <div className={Styles.test_content}>
        {onTestReady && renderTestContent()}
      </div>
    </section>
  );
}
